import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import BoxTypesApiService from './_services/boxTypes.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    boxTypes: [],
    boxTypesTotalCount: 0,
  },
  mutations: {
    [MutationTypes.SET_BOX_TYPES](state, payload) {
      state.boxTypes = payload;
    },
    [MutationTypes.SET_BOX_TYPES_TOTAL_COUNT](state, payload) {
      state.boxTypesTotalCount = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_BOX_TYPES](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, ...rest },
    ) {
      const { totalCount, items } = await BoxTypesApiService.getBoxTypes({ suffix, ...rest });

      commit(MutationTypes.SET_BOX_TYPES, items);
      commit(MutationTypes.SET_BOX_TYPES_TOTAL_COUNT, totalCount);
    },
  },
};
